// measureController — логика инструмента «Измерение» (Fusion-стиль).
//
// Клики по грани/ребру/вершине в 3D добавляют «пики». Держим максимум 2:
//   • 1-й клик  → показываем свойства сущности (длина/площадь/радиус…).
//   • 2-й клик  → показываем минимальное расстояние + угол/дельты.
//   • 3-й клик  → начинаем заново с этой сущности (как во Fusion).
//
// Каждый pick содержит И данные для worker (bodyId/kind/point/normal/mid/len),
// И данные для отрисовки маркера (render: {point, polyline?}).

import useCadStore from '../store/useCadStore';
import { getGeometryClient } from '../geometryClient';

// Монотонный тег запроса — чтобы поздний ответ worker не перезаписал более
// свежий результат (пользователь мог быстро перекликать).
let measureReqTag = 0;

export function addMeasurePick(pick) {
    const store = useCadStore.getState();
    const pf = store.pendingFeature;
    if (!pf || pf.kind !== 'measure') return;

    const cur = Array.isArray(pf.picks) ? pf.picks : [];
    // 3-й клик — сбрасываем к одному новому пику.
    const nextPicks = cur.length >= 2 ? [pick] : [...cur, pick];
    store.updatePendingFeature({ picks: nextPicks, result: null });

    runMeasure(nextPicks);
}

export function clearMeasurePicks() {
    const store = useCadStore.getState();
    const pf = store.pendingFeature;
    if (!pf || pf.kind !== 'measure') return;
    store.updatePendingFeature({ picks: [], result: null });
}

function runMeasure(picks) {
    const tag = ++measureReqTag;
    // Готовим payload для worker — только геометрические поля.
    const payload = picks.map((p) => ({
        bodyId: p.bodyId,
        kind: p.kind,
        point: p.point,
        normal: p.normal || undefined,
        mid: p.mid || undefined,
        len: Number.isFinite(p.len) ? p.len : undefined,
    }));
    getGeometryClient().measure(payload)
        .then((res) => {
            if (tag !== measureReqTag) return; // устаревший ответ
            const store = useCadStore.getState();
            const pf = store.pendingFeature;
            if (!pf || pf.kind !== 'measure') return;
            store.updatePendingFeature({ result: res });
        })
        .catch((err) => {
            if (tag !== measureReqTag) return;
            const store = useCadStore.getState();
            const pf = store.pendingFeature;
            if (!pf || pf.kind !== 'measure') return;
            store.updatePendingFeature({ result: { error: err.message || String(err) } });
        });
}
